export default class VideoPlayer extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.section = el;
    this.videoEl = el.querySelector('[data-video]');
    this.videoType = this.data.type;
    this.videoId = this.data.id;

    if (this.videoType === 'youtube') {
      this.ytPlaceholder = this.section.querySelector('[data-youtube-placeholder]');
      this.ytAttributeString = this.ytPlaceholder.dataset.attributeString;
      this.ytTitle = this.ytPlaceholder.dataset.title;

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this._initYouTube();
            this.videoEl = el.querySelector('[data-video]');
            this._video = Core.Media.createVideo(this.videoEl, this.videoType);
            observer.disconnect();
          }
        });
      }, { threshold: 0 });
      observer.observe(this.section);

    } else {
      this._video = Core.Media.createVideo(this.videoEl, this.videoType);
    }
  }

  _initYouTube() {
    if (this.videoType === 'youtube') {
      this.ytPlaceholder.innerHTML = `
        <iframe
          class="video-player__video"
          src="https://www.youtube.com/embed/${this.videoId}?${this.ytAttributeString}"
          allow="autoplay; encrypted-media"
          allowfullscreen
          title="${this.ytTitle}"
          data-video
        ></iframe>
      `;
    }
  }

  /**
   * Play the video and dispatch video-related events based on resolve/reject from Promise
   * @public
   */
  play() {
    this._video.play();
  }

  /**
   * Pause the video
   * @public
   */
  pause() {
    this._video.pause();
  }

  /**
   * Unload the video on unmount
   */
  onDismount() {
    this._video.unload();
  }
}
